import { render, staticRenderFns } from "./ModalBankAccoutProviderComponent.vue?vue&type=template&id=0a83cdf6"
import script from "./ModalBankAccoutProviderComponent.vue?vue&type=script&lang=js"
export * from "./ModalBankAccoutProviderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports